import { render, staticRenderFns } from "./CommonBottomBar.vue?vue&type=template&id=fd9cc622&scoped=true"
import script from "./CommonBottomBar.vue?vue&type=script&lang=js"
export * from "./CommonBottomBar.vue?vue&type=script&lang=js"
import style0 from "./CommonBottomBar.vue?vue&type=style&index=0&id=fd9cc622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9cc622",
  null
  
)

export default component.exports